var map = {
	"./pages/auth/auth.module": [
		"./src/app/pages/auth/auth.module.ts",
		"default~pages-auth-auth-module~pages-user-profile-user-profile-module",
		"common",
		"pages-auth-auth-module"
	],
	"./pages/dashboard/dashboardModule": [
		"./src/app/pages/dashboard/dashboardModule.ts",
		"pages-dashboard-dashboardModule"
	],
	"./pages/institute-mangements/institute.Management.module": [
		"./src/app/pages/institute-mangements/institute.Management.module.ts",
		"common",
		"pages-institute-mangements-institute-Management-module"
	],
	"./pages/notifications/notifications.module": [
		"./src/app/pages/notifications/notifications.module.ts",
		"common",
		"pages-notifications-notifications-module"
	],
	"./pages/reports/reports.module": [
		"./src/app/pages/reports/reports.module.ts",
		"common",
		"pages-reports-reports-module"
	],
	"./pages/server/server.module": [
		"./src/app/pages/server/server.module.ts",
		"pages-server-server-module"
	],
	"./pages/user-managements/userManagement.Module": [
		"./src/app/pages/user-managements/userManagement.Module.ts",
		"pages-user-managements-userManagement-Module"
	],
	"./pages/user-profile/user.profile.module": [
		"./src/app/pages/user-profile/user.profile.module.ts",
		"default~pages-auth-auth-module~pages-user-profile-user-profile-module",
		"common",
		"pages-user-profile-user-profile-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;